export default __webpack_public_path__ + "static/media/wavy_line.8e328501.svg";